(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/components/dialog/assets/javascripts/dialog-queue.js') >= 0) return;  svs.modules.push('/components/components/dialog/assets/javascripts/dialog-queue.js'); "use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { return function () { var Super = _getPrototypeOf(Derived), result; if (_isNativeReflectConstruct()) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

(function (svs) {
  'use strict';

  svs = svs || {};
  svs.components = svs.components || {};
  svs.components.dialog = svs.components.dialog || {};

  var DialogQueue = function (_svs$components$dialo) {
    _inherits(DialogQueue, _svs$components$dialo);

    var _super = _createSuper(DialogQueue);

    function DialogQueue(options) {
      var _this;

      _classCallCheck(this, DialogQueue);

      _this = _super.call(this);
      _this.log = new svs.core.log.Logger('DialogQueue');
      _this.options = options;
      _this.areas = {};
      _this.at = 0;
      return _this;
    }

    _createClass(DialogQueue, [{
      key: "addEventListeners",
      value: function addEventListeners(area) {
        var _this2 = this;

        area.on('open', this, function () {
          _this2.emit('showDimmer');
        });
        area.on('close', this, function () {
          var popupCount = _this2.areas && _this2.areas[svs.components.dialog.area.POPUP] && _this2.areas[svs.components.dialog.area.POPUP].count();

          var toasterCount = _this2.areas && _this2.areas[svs.components.dialog.area.TOASTER] && _this2.areas[svs.components.dialog.area.TOASTER].count();

          if (_this2.count() === 0) {
            _this2.log.debug('Nothing more to show, remove all');

            _this2.emit('hideDimmer');
          } else if (popupCount === 0 && toasterCount > 0) {
            _this2.emit('hideDimmer');
          }
        });
        area.on('changed', this, function (options) {
          _this2.emit('changed', options);
        });
      }
    }, {
      key: "close",
      value: function close() {
        for (var areaKey in this.areas) {
          if (Object.prototype.hasOwnProperty.call(this.areas, areaKey)) {
            var area = this.areas[areaKey];
            area.close();
          }
        }
      }
    }, {
      key: "closeFromOutside",
      value: function closeFromOutside() {
        for (var areaKey in this.areas) {
          if (Object.prototype.hasOwnProperty.call(this.areas, areaKey)) {
            var area = this.areas[areaKey];

            if (area.closeFromOutside) {
              area.closeFromOutside();
            }
          }
        }
      }
    }, {
      key: "add",
      value: function add(dialog) {
        var dialogArea = dialog.options.area;

        if (dialogArea === svs.components.dialog.area.TOASTER && !dialog.options.convertToPopup && Boolean(this.areas.popup && this.areas.popup.items && this.areas.popup.items.length > 0)) {
          this.log.debug("Do not add toaster with title ".concat(dialog.options.title || '[not set]', " to queue because there is already popups in queue and this toaster has convertToPopup set to false"));
        } else {
          if (!this.areas[dialogArea]) {
            this.areas[dialogArea] = new svs.components.dialog.areas[dialogArea]({
              attachTo: this.options.attachTo,
              areas: this.areas
            });
            this.addEventListeners(this.areas[dialogArea]);
          }

          this.log.debug('Added a dialog to queue');
          this.areas[dialogArea].add(dialog);
          this.log.debug(this.count());
          this.emit('added', dialog);
        }
      }
    }, {
      key: "count",
      value: function count() {
        var itemsInQueue = 0; 

        for (var areaKey in this.areas) {
          if (Object.prototype.hasOwnProperty.call(this.areas, areaKey)) {
            var area = this.areas[areaKey];
            itemsInQueue += area.items.length;
          }
        }

        return itemsInQueue;
      }
    }, {
      key: "status",
      value: function status() {
        var msg = ''; 

        for (var areaKey in this.areas) {
          if (Object.prototype.hasOwnProperty.call(this.areas, areaKey)) {
            var area = this.areas[areaKey];
            msg = "".concat(area.name, " queue, ").concat(area.items.length, " still remain");
          }
        }

        this.log.debug(msg);
      }
    }]);

    return DialogQueue;
  }(svs.components.dialog.PubSub);

  svs.components.dialog.DialogQueue = DialogQueue;
})(svs);
 })(window);